import React, { useEffect } from "react";

export const RelojTotem = () => {

    useEffect(() => {
        const actualizarReloj = () => {
            const now = new Date();

            const fecha = now.toLocaleDateString("es-ES", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            });

            const hora = now.toLocaleTimeString("es-ES", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false
            });

            const div = document.getElementById("relojTotem");
            if (div) div.innerText = `${fecha} ${hora}`;
        };

        actualizarReloj();                     // primera actualización
        const interval = setInterval(actualizarReloj, 1000);

        return () => clearInterval(interval); // limpiar cuando sale
    }, []);

    return (
        <div
            id="relojTotem"
            style={{
                fontSize: "50px",
                // fontWeight: "bold",
                color: "#59CE8F",
                textShadow: "0 0 15px #59CE8F4d",
                marginTop: "10px"
            }}
        >   
            {/* el texto se rellena automáticamente */}
        </div>
    );
};
